import byPageMaker from 'reducersMakers/byPageMaker';
import * as actions from 'actions';

export default byPageMaker([
  actions.FORUM_THREADS_FETCH_SUCCESS,
  actions.FORUM_SIDEBAR_THREADS_FETCH_SUCCESS
], 'forumThreadsIds');



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/forumThreads/byQuery/byPage/reducer.js
 **/